import React from "react";
import { useDispatch } from "react-redux";
import Langs from "../../../app/lang/langs";
import styles from '../VcompCompnents.module.css';
import ImageButton from "../../buttons/ImageButton";
import addIcon from '../../../assets/images/addIconGray.png';
import addIconFocus from '../../../assets/images/addIconOrange.png';
import { setAddQuestionModalVisibility, setAddQuestionFromTree } from "../vcompSlice";
import QuestionsTree from "../QuestionsTree";
import TabNavigationButtons from "./TabNavigationButtons";

/**
 * QuestionsTab - Renders the project questions bank tab (case 2).
 * Shows a questions tree with the ability to add new questions.
 */
export default function QuestionsTab({
    isMobile,
    mode,
    activeIndex,
    setActiveIndex,
    onCreateProject,
    selectedKeys,
    onSelectionChange,
    handleAddDefaultProjectForm,
}) {
    const dispatch = useDispatch();

    return (
        <div className={styles.tabFadeIn}>
            <div
                className={`${isMobile === 2 ? 'mt-5' : ''} ${styles.modalTabCard}`}
                style={isMobile === 2 ? { height: '85%', display: 'flex', flexDirection: 'column' } : {}}
            >
                <div className={styles.tabSectionHeader}>
                    <span className={styles.tabSectionTitle}>
                        <Langs str="PROJECT_QUESTIONS_BANK" />
                    </span>
                    <div className={styles.tabSectionActions}>
                        <ImageButton
                            image={addIcon}
                            imageFocus={addIconFocus}
                            onClick={() => {
                                dispatch(setAddQuestionModalVisibility(true))
                                dispatch(setAddQuestionFromTree(true))
                            }}
                            active={true}
                            width={32}
                        />
                    </div>
                </div>
            </div>
            <QuestionsTree
                onSelectionChange={(selectedKeys) => onSelectionChange(selectedKeys)}
                id_project={onCreateProject.id}
                isMobile={isMobile}
                mode={mode}
                setActiveIndex={setActiveIndex}
                handleAddDefaultProjectForm={handleAddDefaultProjectForm}
            />
            {isMobile !== 2 && (
                <TabNavigationButtons
                    isMobile={isMobile}
                    mode={mode}
                    onNext={() => { setActiveIndex(activeIndex + 1) }}
                    nextLabel="Next"
                />
            )}
        </div>
    );
}
